module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-11-d5660347b57cba47bdd680e271b60f14.svg";